'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var _modals = require('constants/modals');

var _modals2 = require('redux/modules/modals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// will need to import the save and cancel function for this particular subheader
// import { saveGenericSettings, cancelGenericSettings } from 'redux/modules/GenericSettings';

// investigate where confirm is being used, and how modals are being used
// import { CONFIRM } from 'constants/modals';
// import { show as showModal, hide as hideModal } from 'redux/modules/modals';

var ConfigurationSubHeader = function (_Component) {
  (0, _inherits3.default)(ConfigurationSubHeader, _Component);

  function ConfigurationSubHeader() {
    (0, _classCallCheck3.default)(this, ConfigurationSubHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfigurationSubHeader.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationSubHeader)).call(this));

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ConfigurationSubHeader, [{
    key: 'handleSave',
    value: function handleSave() {
      // for saving
      var saveConfiguration = this.props.saveConfiguration;
      var saveGenericSettings = this.props.saveGenericSettings;
      // data to save

      var emailSettings = this.props.genericSettings.emailSettings;
      var configuration = this.props.genericSettings.configuration;
      var oldCFA = this.props.genericSettings.oldCFA;
      var cannedRules = {
        added: this.props.genericSettings.cannedRules.added,
        edited: this.props.genericSettings.cannedRules.edited,
        removed: this.props.genericSettings.cannedRules.removed
      };
      // token
      var token = this.props.codedToken;

      // TODO move stringify to saga
      saveGenericSettings((0, _stringify2.default)({ emailSettings: emailSettings, configuration: configuration, cannedRules: cannedRules, oldCFA: oldCFA }), token);

      saveConfiguration(oldCFA, token);
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      var _this2 = this;

      var confirmMessage = 'CHANGES WILL NOT BE SAVED, ARE YOU SURE YOU WANT TO CONTINUE?';
      this.props.showModal(_modals.CONFIRM, {
        body: confirmMessage,
        onCancel: function onCancel() {
          return _this2.props.hideModal(_modals.CONFIRM);
        },
        onConfirm: function onConfirm() {
          _this2.props.hideModal(_modals.CONFIRM);
          _this2.props.cancelGenericSettings();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var BTN_SIZES = _components.ENTERPRISE_BUTTON_SIZES;
      var BTN_TYPES = _components.ENTERPRISE_BUTTON_TYPES;
      var styles = require('./styles.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('enterprise-subHeader__root', styles.root) },
        _react2.default.createElement(
          'h1',
          { className: (0, _classnames2.default)('enterprise-subHeader__title', styles.title) },
          'Configuration'
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('enterprise-subHeader__actionsWrapper', styles.actionsWrapper) },
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.PRIMARY,
              onClick: this.handleSave
            },
            'SAVE'
          ),
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.SECONDARY,
              onClick: this.handleCancel
            },
            'CANCEL'
          )
        )
      );
    }
  }]);
  return ConfigurationSubHeader;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    codedToken: state.auth.codedToken,
    genericSettings: state.genericSettings
  };
};

var mapDispatchToProps = {
  saveGenericSettings: _GenericSettings.saveGenericSettings.base,
  saveConfiguration: _GenericSettings.saveConfiguration.base,
  cancelGenericSettings: _GenericSettings.cancelGenericSettings,
  showModal: _modals2.show,
  hideModal: _modals2.hide
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfigurationSubHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConfigurationSubHeader/ConfigurationSubHeader.jsx
// module id = 1622
// module chunks = 0